import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconSwapVertLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.163 12.644a.725.725 0 0 1-.534-.216.726.726 0 0 1-.215-.534v-6.53L6.096 7.68a.68.68 0 0 1-.507.207.767.767 0 0 1-.77-.752c0-.2.078-.379.233-.534l3.47-3.47a.822.822 0 0 1 .297-.197 1.001 1.001 0 0 1 .678 0 .811.811 0 0 1 .3.198l3.493 3.494a.699.699 0 0 1 .22.517.788.788 0 0 1-.763.752.7.7 0 0 1-.526-.225L9.914 5.363v6.54a.73.73 0 0 1-.75.74Zm5.682 8.47a.998.998 0 0 1-.341-.059.808.808 0 0 1-.3-.197l-3.495-3.495a.7.7 0 0 1-.22-.517.788.788 0 0 1 .763-.752.698.698 0 0 1 .527.225l2.307 2.308v-6.54a.73.73 0 0 1 .75-.74c.213 0 .392.071.535.215a.727.727 0 0 1 .215.534v6.531l2.318-2.317a.68.68 0 0 1 .507-.208.767.767 0 0 1 .77.752c0 .201-.078.38-.233.535l-3.47 3.469a.826.826 0 0 1-.296.198.97.97 0 0 1-.337.057Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconSwapVertLine;
